import {ISearchable} from './Searchable.itf'
/**
* @typedef  PoissonCodeConstructor
* @type {object}
* @property {Object} idCode - the idCode value
* @property {Object} idPoisson - the idPoisson value
* @property {Object} idTaille - the idTaille value
* @property {Object} idConditionnement - the idConditionnement value
* @property {Object} code - the code value
* @property {Object} idOrigine - the idOrigine value
* @property {Object} idQualite - the idQualite value
* @author generator-sqlite
* */
export class PoissonCode extends ISearchable {
  /**
   * Creates an instance of PoissonCode.
   * @memberof PoissonCode
   * @author generator-sqlite
   * */
  constructor(object) {
    super()
    this.idCode = object.idCode
    this.idPoisson = object.idPoisson
    this.idTaille = object.idTaille
    this.idDenomination = object.idDenomination
    this.idConditionnement = object.idConditionnement
    this.idOrigine = object.idOrigine
    this.idQualite = object.idQualite
    this.idLabel = object.idLabel
    this.idPreparation = object.idPreparation
    this.idProduitTransforme = object.idProduitTransforme
    this.idCodeMagasin = object.idCodeMagasin
    this.idProduitLS = object.idProduitLS
    this.plu = object.plu
    this.ean = object.ean

    if (object.nom) {
      this.nom = object.nom
    }
  }

  formatToDisplay() {
    this.lineClassName = 'codeLine'
    this.boxClassName = 'codeBox'
    this.displayType = 'Code Poisson'
    this.nom = `${this.nom}`
    this.raccourci = this.nom
    this.created = true
    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-codeLine'
    return this
  }

  getNameAttribute() {
    return 'nom'
  }

  getIdAttribute() {
    return 'idCode'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
